import { HttpClient } from './HttpClient';
import { getApiUrl } from './UrlBuilder';

import { Training } from 'models';
import { UserManager, HALManager } from 'core';

export class TrainingService {
  private httpClient: HttpClient = new HttpClient();

  public async getTraining() {
    const urlRequest = getApiUrl(HALManager.getTrainingUrl(UserManager.userId));

    const response = await this.httpClient.get<Training>(urlRequest);

    return response.object;
  };

  public async updateTraining(aboutMe: Training) {
    const urlRequest = getApiUrl(HALManager.updateTrainingUrl(UserManager.userId));

    const requestParams = { body: JSON.stringify(aboutMe) };

    const response = await this.httpClient.put<Training>(urlRequest, requestParams);

    return response.object;
  };
}

export default new TrainingService();